module.exports = __webpack_public_path__ + "5c114213/img/saly-icon.39e12342.jpg";